'use strict'
import ModulHandBuchAPI from '../../api/modulHandBuch'

const UPLOAD_MODULHANDBUECHER = 'UPLOAD_MODULHANDBUECHER',
    UPLOAD_MODULHANDBUECHER_SUCCESS = 'UPLOAD_MODULHANDBUECHER_SUCCESS',
    UPLOAD_MODULHANDBUECHER_ERROR = 'UPLOAD_MODULHANDBUECHER_ERROR',
    FETCHING_MODULHANDBUECHER = 'FETCHING_MODULHANDBUECHER',
    FETCHING_MODULHANDBUECHER_SUCCESS = 'FETCHING_MODULHANDBUECHER_SUCCESS',
    FETCHING_MODULHANDBUECHER_ERROR = 'FETCHING_MODULHANDBUECHER_ERROR'
export default {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
        modulHandBuecher: []
    },
    getters: {
        getModulHandBuchById(state) {
            return (modulhandbuchId) =>
                state.modulHandBuecher.find(
                    (modulhandbuch) => modulhandbuch.modulhandbuchId === modulhandbuchId
                )
        },
        getModulHandBuchByIri(state) {
            return (modulhandbuchIri) =>
                state.modulHandBuecher.find(
                    (modulhandbuch) => modulhandbuch['@id'] === modulhandbuchIri
                )
        },
        getModulHandBuchByStudiengangId(state) {
            return (studiengangId) =>
                state.modulHandBuecher.filter(
                    (modulhandbuch) => modulhandbuch.studiengangId === studiengangId
                )
        },
        modulHandBuecher(state) {
            return state.modulHandBuecher
        },
        isLoading(state) {
            return state.isLoading
        },
        hasError(state) {
            return state.error !== null
        },
        error(state) {
            return state.error
        },
        hasModulHandBuecher(state) {
            return state.modulHandBuecher.length > 0
        }
    },
    mutations: {
        [FETCHING_MODULHANDBUECHER](state) {
            state.isLoading = true
            state.error = null
            state.modulHandBuecher = []
        },
        [FETCHING_MODULHANDBUECHER_SUCCESS](state, modulHandBuecher) {
            state.isLoading = false
            state.error = null
            state.modulHandBuecher = [...modulHandBuecher]
        },
        [FETCHING_MODULHANDBUECHER_ERROR](state, error) {
            state.isLoading = false
            state.error = error
        },
        [UPLOAD_MODULHANDBUECHER](state) {
            state.isLoading = true
            state.error = null
        },
        [UPLOAD_MODULHANDBUECHER_SUCCESS](state) {
            state.error = null
            state.isLoading = false
        },
        [UPLOAD_MODULHANDBUECHER_ERROR](state, error) {
            state.error = error
            state.isLoading = false
        }
    },
    actions: {
        async findAll({ commit }) {
            commit(FETCHING_MODULHANDBUECHER)
            try {
                let response = await ModulHandBuchAPI.findAll()
                commit(FETCHING_MODULHANDBUECHER_SUCCESS, response.data['hydra:member'])
                return response.data['hydra:member']
            } catch (error) {
                commit(FETCHING_MODULHANDBUECHER_ERROR, error)
                return null
            }
        },
        async uploadModulHandBuecherFile({ commit, dispatch }, file) {
            commit(UPLOAD_MODULHANDBUECHER)
            try {
                await ModulHandBuchAPI.uploadModulHandBuecher(file)
                commit(UPLOAD_MODULHANDBUECHER_SUCCESS)
                await dispatch('modulHandBuch/findAll', {}, { root: true })

                return true
            } catch (error) {
                commit(UPLOAD_MODULHANDBUECHER_ERROR, error)
                return null
            }
        }
    }
}
